import { Component, OnInit } from '@angular/core';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserData } from 'src/app/models/user.model';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.css']
})
export class PersonalInfoComponent implements OnInit {
  userData: Partial<UserData> = {
    publicName: '',
    description: '',
    email: '',
    telephone: '',
    ville: '',
    profession: ''
  };
  
  isLoading = false;
  isEditing = false;
  firestore = new FirebaseTSFirestore();
  auth = new FirebaseTSAuth();

  constructor(private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.loadUserData();
  }

  loadUserData() {
    const userId = this.auth.getAuth().currentUser?.uid;
    if (userId) {
      this.isLoading = true;
      this.firestore.getDocument({
        path: ["Users", userId],
        onComplete: result => {
          const data = result.data();
          this.userData = {
            publicName: data.publicName || '',
            email: data.email || '',
            telephone: data.telephone || '',
            ville: data.ville || '',
            profession: data.profession || '',
            description: data.description || '',
            ...data
          };
          this.isLoading = false;
        },
        onFail: err => {
          console.error('Erreur lors du chargement des données:', err);
          this.snackBar.open('Erreur lors du chargement des informations', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
        }
      });
    }
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  saveChanges() {
    const userId = this.auth.getAuth().currentUser?.uid;
    if (userId) {
      this.isLoading = true;
      
      // Créer une copie des données à mettre à jour
      const updateData = {
        publicName: this.userData.publicName,
        email: this.userData.email,
        telephone: this.userData.telephone,
        ville: this.userData.ville,
        profession: this.userData.profession,
        description: this.userData.description
      };

      this.firestore.update({
        path: ["Users", userId],
        data: updateData,
        onComplete: () => {
          this.snackBar.open('Informations mises à jour avec succès', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
          this.isEditing = false;
        },
        onFail: err => {
          console.error('Erreur lors de la mise à jour:', err);
          this.snackBar.open('Erreur lors de la mise à jour des informations', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
        }
      });
    }
  }

  cancelEdit() {
    this.isEditing = false;
    this.loadUserData(); // Recharger les données originales
  }
}
